import { render, staticRenderFns } from "./DishImage.vue?vue&type=template&id=6e275d4b&scoped=true"
import script from "./DishImage.vue?vue&type=script&lang=js"
export * from "./DishImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e275d4b",
  null
  
)

export default component.exports